export default __webpack_public_path__ + "static/spark_naver_2FA1-22aa5bcd2a4c062ad20c764e4bb1398b.png";